import type { ReactNode } from "react";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { CertificationButton } from "./CertificationButton";

type Props = {
  eyebrow: string;
  title: string;
  description: string;
  standardLabel: string;
  onBack: () => void;
  onRefresh?: () => void;
  refreshing?: boolean;
  actions?: ReactNode;
};

export function CertificationSectionHeader({
  eyebrow,
  title,
  description,
  standardLabel,
  onBack,
  onRefresh,
  refreshing = false,
  actions,
}: Props) {
  return (
    <header className="iso27001-section-header">
      <div className="iso27001-section-header-copy">
        <div className="iso27001-section-eyebrow">{eyebrow}</div>
        <div className="iso27001-section-title-row">
          <h2>{title}</h2>
          <span className="iso27001-section-standard">{standardLabel}</span>
        </div>
        <p>{description}</p>
      </div>
      <div className="iso27001-section-header-actions">
        {actions}
        {onRefresh ? (
          <CertificationButton
            variant="secondary"
            icon={<RefreshCw size={15} className={refreshing ? "animate-spin" : ""} />}
            onClick={onRefresh}
            disabled={refreshing}
          >
            <span style={{ color: "#0b4a2f" }}>Actualizar</span>
          </CertificationButton>
        ) : null}
        <CertificationButton
          variant="secondary"
          icon={<ArrowLeft size={15} />}
          onClick={onBack}
        >
          <span style={{ color: "#0b4a2f" }}>Volver</span>
        </CertificationButton>
      </div>
    </header>
  );
}
